$(document).ready(function() {
  // PULL URL QUERY AND ASSIGN
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // STYLE
  var style = "Adelaide";
  if (urlParams.has('style')) {
    style = urlParams.get('style');
    document.getElementById("style").value = style;
    updateOptions();
  }

  // MATERIAL
  if (urlParams.has('material')) {
    var material = urlParams.get('material');
    document.getElementById("material").value = material;
  }

  // RING SIZE
  if (urlParams.has('ring_size')) {
    var ringSize = urlParams.get('ring_size');
    document.getElementById("ring_size").value = ringSize;
  }

  // STONE QUANTITY
  if (urlParams.has('stone_quantity')) {
    var stoneQuantity = urlParams.get('stone_quantity');
    document.getElementById("stone_quantity").value = stoneQuantity;
  }

  // CARAT WEIGHT
  if (urlParams.has('carat_weight')) {
    var caratWeight = urlParams.get('carat_weight');
    document.getElementById("carat_weight").value = caratWeight;
  }

  // COLOR ARRANGEMENT
  if (urlParams.has('color_arrangement')) {
    var colorArrangement = urlParams.get('color_arrangement');
    document.getElementById("color_arrangement").value = colorArrangement;
  }

  // FIRST GEMSTONE COLOR
  if (urlParams.has('first_gemstone_color')) {
    var firstGemstoneColor = urlParams.get('first_gemstone_color');
    document.getElementById("first_gemstone_color").value = firstGemstoneColor;
  }

  // SECOND GEMSTONE COLOR
  if (urlParams.has('second_gemstone_color')) {
    var secondGemstoneColor = urlParams.get('second_gemstone_color');
    document.getElementById("second_gemstone_color").value = secondGemstoneColor;
  }

  // THIRD GEMSTONE COLOR
  if (urlParams.has('third_gemstone_color')) {
    var thirdGemstoneColor = urlParams.get('third_gemstone_color');
    document.getElementById("third_gemstone_color").value = thirdGemstoneColor;
  }
  
  updateAll("style", style, "none");

  var twoWeeksAway = new Date(Date.now() + 12096e5);
  var dd = twoWeeksAway.getDate();
  var mm = twoWeeksAway.getMonth()+1; //January is 0!
  var yyyy = twoWeeksAway.getFullYear();
  if(dd<10){
    dd='0'+dd
  }
  if(mm<10){
    mm='0'+mm
  }

  twoWeeksAway = yyyy+'-'+mm+'-'+dd;
  document.getElementById("rushDate").setAttribute("min", twoWeeksAway);
});

function getURLQuery() {
  var urlQuery = "https://originjewelry.com/pages/custom-ring-design-tool?";

  // STYLE
  var style = document.getElementById("style").value;
  urlQuery = urlQuery.concat("&style=");
  urlQuery = urlQuery.concat(style);
  
  // MATERIAL
  var material = document.getElementById("material").value;
  urlQuery = urlQuery.concat("&material=");
  urlQuery = urlQuery.concat(material);

  // RING SIZE
  var ringSize = document.getElementById("ring_size").value;
  urlQuery = urlQuery.concat("&ring_size=");
  urlQuery = urlQuery.concat(ringSize);

  // STONE QUANTITY
  var stoneQuantity = document.getElementById("stone_quantity").value;
  urlQuery = urlQuery.concat("&stone_quantity=");
  urlQuery = urlQuery.concat(stoneQuantity);

  // CARAT WEIGHT
  var caratWeight = document.getElementById("carat_weight").value;
  urlQuery = urlQuery.concat("&carat_weight=");
  urlQuery = urlQuery.concat(caratWeight);

  // COLOR ARRANGEMENT
  var colorArrangement = document.getElementById("color_arrangement").value;
  urlQuery = urlQuery.concat("&color_arrangement=");
  urlQuery = urlQuery.concat(colorArrangement);

  // FIRST GEMSTONE COLOR
  var firstGemstoneColor = document.getElementById("first_gemstone_color").value;
  urlQuery = urlQuery.concat("&first_gemstone_color=");
  urlQuery = urlQuery.concat(firstGemstoneColor);

  // SECOND GEMSTONE COLOR
  var secondGemstoneColor = document.getElementById("second_gemstone_color").value;
  urlQuery = urlQuery.concat("&second_gemstone_color=");
  urlQuery = urlQuery.concat(secondGemstoneColor);

  // THIRD GEMSTONE COLOR
  var thirdGemstoneColor = document.getElementById("third_gemstone_color").value;
  urlQuery = urlQuery.concat("&third_gemstone_color=");
  urlQuery = urlQuery.concat(thirdGemstoneColor);
  
  history.replaceState({}, '', urlQuery);
}

function updateAll(name, value, gaType) {
  updateSelectedOption(name, value);
  updateSelectedImage(name, value);
  updateSelectionField(name, value);
  updateOptions();
  updateCustomImage();
  updateAllSelections();

  checkMaterialDislaimers();
  checkInvoiceSubmit();
}

function checkMaterialDislaimers() {
  var ringMaterial = document.getElementById('material').value;

  var bzDisclaimer = '<li class="disclaimer">Black Zirconium is the darkest metal available; however, it is not pure black and in some lighting it can appear to be dark grey. <a href="/pages/black-zirconium-ring-info" rel="nofollow" target="_blank">Click here to learn more about black zirconium</a>.</li>';
  
  var disclaimers = '<p class="disclaimer">This ring comes with a comfort-fit inside the ring, which means that the center of the ring is true to size and gets slightly larger toward the edges of the ring. The comfort fit makes it easier to get the ring on and off, and fits more comfortably on the finger. Keeping that in mind, some people like to order their ring slightly smaller than their ring size (normally a quarter size smaller), if they like their rings to be snug on their finger.</p>';
  if (ringMaterial == 'Black Zirconium') {
    disclaimers = '<li class="disclaimer">This ring comes with a comfort-fit inside the ring, which means that the center of the ring is true to size and gets slightly larger toward the edges of the ring. The comfort fit makes it easier to get the ring on and off, and fits more comfortably on the finger. Keeping that in mind, some people like to order their ring slightly smaller than their ring size (normally a quarter size smaller), if they like their rings to be snug on their finger.</li>';
  }
  if (ringMaterial == 'Black Zirconium') {
    disclaimers = disclaimers.concat(bzDisclaimer);
  }

  document.getElementById('material_disclaimers').innerHTML = disclaimers;
}

function checkInvoiceSubmit() {
  var notes = document.getElementById('notes');
  var priceEstimate = document.getElementById('price_estimate');
  var ringSize = document.getElementById('ring_size');

  if (notes != null && priceEstimate != null && ringSize != null && notes.value == "" && priceEstimate.value != "Submit Request for Pricing" && ringSize.value != "Other") {
    $('#customInvoice').show();
  } else {
    $('#customInvoice').hide();
  }
}

function updatePrice(src) {
  var origin = document.getElementById('origin').value;
  var rushDate = document.getElementById('rushDate').value;
  var size = document.getElementById('ring_size').value;

  var price = document.getElementById('price');
  var priceSelection = document.getElementById('price_selection');
  var priceEstimate = document.getElementById('price_estimate');
  var salePriceEstimate = document.getElementById('sale_price_estimate');
  var ringMaterial = document.getElementById('material').value;

  price.innerText = "---";
  priceSelection.innerText = "---";
  priceEstimate.value = "---";

  $.ajax({
    type: "POST",
    url: "https://custom.stonebrookjewelry.com/origin/get_price.php",
    data: { ext: src, origin: origin, rushDate: rushDate, size: size },
    success: function(returnedData){
      if (returnedData.price != "NAN") {
        if (returnedData.sale_price != returnedData.price) {
          if (Shopify.currency.active == "USD") {
            // price.innerHTML = "Price: ".concat("<span class='money' style='color: #a71616;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.sale_price)).concat("</span> ").concat("<span class='money' style='text-decoration: line-through !important;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.price)).concat("</span>");
            // priceSelection.innerHTML = "<span class='money' style='color: #a71616;'>".concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.sale_price)).concat("</span> ").concat("<span class='money' style='text-decoration: line-through !important;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.price)).concat("</span>");
            price.innerHTML = "Price: <span class='money' style='color: #a71616;'>$".concat(returnedData.sale_price).concat("</span> <span class='money' style='text-decoration: line-through !important;'>$").concat(returnedData.price).concat("</span> USD");
            priceSelection.innerHTML = "<span class='money' style='color: #a71616;'>$".concat(returnedData.sale_price).concat("</span> <span class='money' style='text-decoration: line-through !important;'>$").concat(returnedData.price).concat("</span> USD");
            priceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            salePriceEstimate.value = "$".concat(returnedData.sale_price).concat(" USD");
          } else {
            price.innerHTML = "Price: ".concat("<span class='money' style='color: #a71616;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.sale_price) * parseFloat(Shopify.currency.rate)))).concat("</span> ").concat("<span class='money' style='text-decoration: line-through !important;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.price) * parseFloat(Shopify.currency.rate)))).concat("</span>");
            priceSelection.innerHTML = "<span class='money' style='color: #a71616;'>".concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.sale_price) * parseFloat(Shopify.currency.rate)))).concat("</span> ").concat("<span class='money' style='text-decoration: line-through !important;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.price) * parseFloat(Shopify.currency.rate)))).concat("</span>");
            priceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            salePriceEstimate.value = "$".concat(returnedData.sale_price).concat(" USD");
          }
        } else {
          if (Shopify.currency.active == "USD") {
            price.innerHTML = "Price: ".concat("<span class='money'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.price)).concat("</span>");
            priceSelection.innerHTML = "<span class='money'>".concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.price)).concat("</span>");
            priceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            salePriceEstimate.value = "$".concat(returnedData.price).concat(" USD");
          } else {
            price.innerHTML = "Price: ".concat("<span class='money'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.price) * parseFloat(Shopify.currency.rate)))).concat("</span>");
            priceSelection.innerHTML = "<span class='money'>".concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.price) * parseFloat(Shopify.currency.rate)))).concat("</span>");
            priceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            salePriceEstimate.value = "$".concat(returnedData.price).concat(" USD");
          }
        }
        
        var src = "https://assets.lashbrookdesigns.com";
        src = src.concat(returnedData.image_src);
        if (src != "") {
          src = src.concat("&watermark=false");
          src = src.concat("&image_size=");
        
          if ($('#mobileCustomImg').first().is(':visible')) {
            document.getElementById("centerLoad").style.display = "block";
          }
          var smallImg = new Image();
          smallImg.src = src.concat("200");
          smallImg.crossOrigin = "Anonymous";
          smallImg.addEventListener("load", function() { drawSmallImage(smallImg); }, false);
        
          if ($('#leftMobileCustomImg').first().is(':visible')) {
            document.getElementById("leftLoad").style.display = "block";
          }
          var smallLeftImg = new Image();
          smallLeftImg.src = src.concat("200").replace("images/1","images/2");
          smallLeftImg.crossOrigin = "Anonymous";
          smallLeftImg.addEventListener("load", function() { drawSmallLeftImage(smallLeftImg); }, false);
        
          if ($('#rightMobileCustomImg').first().is(':visible')) {
            document.getElementById("rightLoad").style.display = "block";
          }
          var smallRightImg = new Image();
          smallRightImg.src = src.concat("200").replace("images/1","images/3");
          smallRightImg.crossOrigin = "Anonymous";
          smallRightImg.addEventListener("load", function() { drawSmallRightImage(smallRightImg); }, false);
        
          document.getElementById("topImgLoad").style.display = "block";
          var canvas = document.getElementById("topImg");
          var ctx = canvas.getContext("2d");
          ctx.fillStyle = "#FFFFFF";
          ctx.fillRect(0, 0, 700, 700);
          var largeImg = new Image();
          largeImg.src = src.concat("700");
          largeImg.crossOrigin = "Anonymous";
          largeImg.addEventListener("load", function() { drawLargeImage(largeImg); }, false);
        
          document.getElementById("imageURL").value = src.concat("700");
        }
      } else {
        price.innerText = "Submit Request for Pricing";
        priceSelection.innerText = "Submit Request for Pricing";
        priceEstimate.value = "Submit Request for Pricing";
        salePriceEstimate.value = "Submit Request for Pricing";
      }
      checkInvoiceSubmit();
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      price.innerText = "Submit Request for Pricing";
      priceSelection.innerText = "Submit Request for Pricing";
      priceEstimate.value = "Submit Request for Pricing";
      salePriceEstimate.value = "Submit Request for Pricing";

      console.log("XMLHttpRequest: ");
      console.log(XMLHttpRequest);
      console.log("textStatus: ");
      console.log(textStatus);
      console.log("errorThrown: ");
      console.log(errorThrown);
      checkInvoiceSubmit();
    }
  });
}

function updateAllSelections() {
  updateSelectedOption("style", document.getElementById("style").value);
  updateSelectedOption("material", document.getElementById("material").value);
  updateSelectedOption("stone_quantity", document.getElementById("stone_quantity").value);
  updateSelectedOption("carat_weight", document.getElementById("carat_weight").value);
  updateSelectedOption("color_arrangement", document.getElementById("color_arrangement").value);
  updateSelectedOption("first_gemstone_color", document.getElementById("first_gemstone_color").value);
  updateSelectedOption("second_gemstone_color", document.getElementById("second_gemstone_color").value);
  updateSelectedOption("third_gemstone_color", document.getElementById("third_gemstone_color").value);
  updateSelectedImage("style", document.getElementById("style").value);
  updateSelectedImage("material", document.getElementById("material").value);
  updateSelectedImage("first_gemstone_color", document.getElementById("first_gemstone_color").value);
  updateSelectedImage("second_gemstone_color", document.getElementById("second_gemstone_color").value);
  updateSelectedImage("third_gemstone_color", document.getElementById("third_gemstone_color").value);
  updateSelectionField("style", document.getElementById("style").value);
  updateSelectionField("material", document.getElementById("material").value);
  updateSelectionField("stone_quantity", document.getElementById("stone_quantity").value);
  updateSelectionField("carat_weight", document.getElementById("carat_weight").value);
  updateSelectionField("color_arrangement", document.getElementById("color_arrangement").value);
  updateSelectionField("first_gemstone_color", document.getElementById("first_gemstone_color").value);
  updateSelectionField("second_gemstone_color", document.getElementById("second_gemstone_color").value);
  updateSelectionField("third_gemstone_color", document.getElementById("third_gemstone_color").value);
  updateSelectionField("rush_date", document.getElementById("rushDate").value);
  updateSelectionField("notes", document.getElementById("notes").value);
}

function updateSelectedOption(name, value) {
  var selector = '[name="'.concat(name).concat('"]');
  var selects = $(selector);
  if (selects.length > 0) {
    var select = selects[0];
    var options = select.options;
    for (var opt, j = 0; opt = options[j]; j++) {
      if (opt.value == value) {
        select.selectedIndex = j;
        break;
      }
    }
  }
}

function updateSelectedImage(name, value) {
  var classSelector = '.'.concat(name).concat(' .pattern-image');
  var imageContainers = $(classSelector);
  if (imageContainers.length > 0) {
    for (var i = 0; i < imageContainers.length; i++) {
      if (imageContainers[i].parentElement.getAttribute("data-value") == value) {
        imageContainers[i].style.border = "2px solid #333";
        imageContainers[i].style.padding = "3px";
      } else if (imageContainers[i].parentElement.getAttribute("data-value") != null && imageContainers[i].parentElement.getAttribute("data-value").toLowerCase() != name) {
        imageContainers[i].style.border = "transparent";
        imageContainers[i].style.padding = "5px";
      }
    }
  }
}

function updateSelectionField(name, value) {
  var id = '#'.concat(name).concat("_selection_container");
  var elements = $(id);
  var elementId = name.concat("_selection");
  if (document.getElementById(elementId) != null) {
    var element = document.getElementById(elementId);
    if (value == "") {
      element.innerHTML = "None Selected";
      if (name != "style" && name != "material") {
        elements.hide();
      }
    } else {
      element.innerHTML = value;
      elements.show();
    }
  }
}

function updateOptions() {
  // Materials
  var allStyleMaterials = ["10k White Gold", "10k Yellow Gold", "14k Rose Gold", "14k White Gold", "14k Yellow Gold", "18k Rose Gold", "18k White Gold", "18k Yellow Gold", "Black Titanium", "Black Zirconium", "Platinum"];
  var allOtherStyleMaterials = ["10k White Gold", "10k Yellow Gold", "14k Rose Gold", "14k White Gold", "14k Yellow Gold", "18k Rose Gold", "18k White Gold", "18k Yellow Gold", "Platinum"];
  var styleValue = document.getElementById('style').value;

  var availableMaterials = allOtherStyleMaterials;
  if (styleValue == "Adelaide") {
    availableMaterials = allStyleMaterials;
  }
  
  // availableInteriorPatterns = joinArrays(availableInteriorPatterns, interiorPatterns6mm);

  updateSelectOptions("material", availableMaterials);
  updateSelectImages("material", availableMaterials);

  // TCWs
  var style10TCW = [".315 TCW", ".45 TCW", ".65 TCW", ".77 TCW"];
  var style11TCW = [".6 TCW", ".84 TCW", "1.1 TCW"];
  var style12TCW = [".33 TCW", ".9 TCW"];
  var style13TCW = [".225 TCW", ".36 TCW", ".5 TCW", ".63 TCW"];
  var style14TCW = [".27 TCW", ".39 TCW", ".55 TCW", ".77 TCW"];
  var style15TCW = [".27 TCW", ".39 TCW", ".55 TCW", ".77 TCW"];
  var style16TCW = [".285 TCW", ".62 TCW", ".85 TCW"];
  var style17TCW = [".285 TCW", ".62 TCW", ".85 TCW"];
  var style18TCW = [".315 TCW", ".45 TCW", ".65 TCW", ".77 TCW"];
  var style19TCW = [".33 TCW", ".68 TCW"];
  var style20TCW = [".69 TCW", "1.08 TCW", "1.5 TCW"];
  var style21TCW = [".56 TCW"];
  var style22TCW = [".78 TCW", "1.38 TCW", "1.72 TCW", "2.15 TCW"];
  var style23TCW = ["1.32 TCW"];
  var style24TCW = [".825 TCW", "1.29 TCW", "1.85 TCW"];
  var style25TCW = ["1.395 TCW"];
  var style26TCW = [".87 TCW"];
  var style27TCW = [".39 TCW", ".54 TCW", ".8 TCW"];
  var style28TCW = [".195 TCW", ".27 TCW", ".4 TCW"];
  var style29TCW = [".27 TCW", ".47 TCW"];
  var style30TCW = [".39 TCW", ".42 TCW"];
  var style31TCW = [".23 TCW", ".27 TCW"];
  var style32TCW = [".62 TCW"];

  availableTCWs = style10TCW;
  if (styleValue == "Adelaide") {
    availableTCWs = style10TCW;
  } else if (styleValue == "Alexandra") {
    availableTCWs = style11TCW;
  } else if (styleValue == "Amelia") {
    availableTCWs = style12TCW;
  } else if (styleValue == "Catherine") {
    availableTCWs = style13TCW;
  } else if (styleValue == "Charlotte") {
    availableTCWs = style14TCW;
  } else if (styleValue == "Diana") {
    availableTCWs = style15TCW;
  } else if (styleValue == "Eleanor") {
    availableTCWs = style16TCW;
  } else if (styleValue == "Elizabeth") {
    availableTCWs = style17TCW;
  } else if (styleValue == "Georgiana") {
    availableTCWs = style18TCW;
  } else if (styleValue == "Louise") {
    availableTCWs = style19TCW;
  } else if (styleValue == "Margaret") {
    availableTCWs = style20TCW;
  } else if (styleValue == "Victoria") {
    availableTCWs = style21TCW;
  } else if (styleValue == "Antoinette") {
    availableTCWs = style22TCW;
  } else if (styleValue == "Arabella") {
    availableTCWs = style23TCW;
  } else if (styleValue == "Clarissa") {
    availableTCWs = style24TCW;
  } else if (styleValue == "Emmeline") {
    availableTCWs = style25TCW;
  } else if (styleValue == "Josephine") {
    availableTCWs = style26TCW;
  } else if (styleValue == "Aurelia") {
    availableTCWs = style27TCW;
  } else if (styleValue == "Isabella") {
    availableTCWs = style28TCW;
  } else if (styleValue == "Camilla") {
    availableTCWs = style29TCW;
  } else if (styleValue == "Helena") {
    availableTCWs = style30TCW;
  } else if (styleValue == "Theodora") {
    availableTCWs = style31TCW;
  } else if (styleValue == "Sophia") {
    availableTCWs = style32TCW;
  }

  updateSelectOptions("carat_weight", availableTCWs);

  // Colors Arrangements
  var singlColorArrangement = ["Single Color"];
  var alternatingColorArrangment = ["Alternating Colors"]
  var allColorArrangements = ["Single Color", "Alternating Colors"]

  availableColorArrangements = singlColorArrangement;
  if (styleValue == "Adelaide" || styleValue == "Alexandra" || styleValue == "Amelia" || styleValue == "Catherine" || styleValue == "Charlotte" || styleValue == "Elizabeth" || styleValue == "Louise" || styleValue == "Margaret" || styleValue == "Antoinette" || styleValue == "Arabella" || styleValue == "Clarissa" || styleValue == "Emmeline" || styleValue == "Josephine" || styleValue == "Aurelia" || styleValue == "Isabella" || styleValue == "Sophia") {
    availableColorArrangements = singlColorArrangement;
  } else if (styleValue == "Diana" || styleValue == "Eleanor" || styleValue == "Georgiana" || styleValue == "Victoria" || styleValue == "Camilla" || styleValue == "Helena" || styleValue == "Theodora") {
    availableColorArrangements = allColorArrangements;
  }

  updateSelectOptions("color_arrangement", availableColorArrangements);

  var color_arrangement = document.getElementById('color_arrangement').value;
  var gemstoneColors = ["Aqua Diamond", "Black Diamond", "Blue Sapphire", "Chocolate Diamond", "Dark Ruby", "Denim Blue Sapphire", "Green Diamond", "Light Pink Sapphire", "Light Yellow Sapphire", "Ocean Blue Diamond", "Pink Sapphire", "Purple Diamond", "Ruby", "White Diamond", "White Lab Diamond", "Yellow Sapphire"];
  var gemstoneSapphireWithWhiteDiamondColors = ["Blue Sapphire", "Dark Ruby", "Denim Blue Sapphire", "Light Pink Sapphire", "Light Yellow Sapphire", "Pink Sapphire", "Ruby", "White Diamond", "White Lab Diamond", "Yellow Sapphire"];
  var gemstoneWhiteLabDiamondColors = ["White Lab Diamond"];
  var gemstoneSapphireWithWhitePurpleDiamondColors = ["Blue Sapphire", "Dark Ruby", "Denim Blue Sapphire", "Light Pink Sapphire", "Light Yellow Sapphire", "Pink Sapphire", "Purple Diamond", "Ruby", "White Diamond", "White Lab Diamond", "Yellow Sapphire"];
  var availableFirstGemstoneColors = gemstoneWhiteLabDiamondColors;
  
  // 1st Color
  if (styleValue == "Adelaide" || styleValue == "Catherine" || styleValue == "Charlotte" || styleValue == "Elizabeth" || styleValue == "Louise" || styleValue == "Margaret" || styleValue == "Antoinette" || styleValue == "Arabella" || styleValue == "Clarissa" || styleValue == "Emmeline" || styleValue == "Aurelia" || styleValue == "Isabella" || styleValue == "Camilla") {
    availableFirstGemstoneColors = gemstoneColors;
  } else if (styleValue == "Alexandra") {
    availableFirstGemstoneColors = gemstoneSapphireWithWhiteDiamondColors;
  } else if (styleValue == "Amelia" || styleValue == "Sophia") {
    availableFirstGemstoneColors = gemstoneWhiteLabDiamondColors;
  } else if ((styleValue == "Diana" || styleValue == "Eleanor" || styleValue == "Georgiana" || styleValue == "Victoria") && color_arrangement == "Single Color") {
    availableFirstGemstoneColors = gemstoneWhiteLabDiamondColors;
  } else if ((styleValue == "Diana" || styleValue == "Eleanor" || styleValue == "Georgiana" || styleValue == "Victoria") && color_arrangement == "Alternating Colors") {
    availableFirstGemstoneColors = gemstoneColors;
  } else if (styleValue == "Josephine") {
    availableFirstGemstoneColors = gemstoneSapphireWithWhitePurpleDiamondColors;
  } else if (styleValue == "Helena" && color_arrangement == "Single Color") {
    availableFirstGemstoneColors = gemstoneSapphireWithWhiteDiamondColors;
  } else if (styleValue == "Helena" && color_arrangement == "Alternating Colors") {
    availableFirstGemstoneColors = gemstoneColors;
  } else if (styleValue == "Theodora") {
    availableFirstGemstoneColors = gemstoneSapphireWithWhitePurpleDiamondColors;
  }
  updateSelectOptions("first_gemstone_color", availableFirstGemstoneColors);
  updateSelectImages("first_gemstone_color", availableFirstGemstoneColors);
  
  // 2nd Color
  var availableSecondGemstoneColors = [];
  
  if ((styleValue == "Diana" || styleValue == "Eleanor" || styleValue == "Georgiana" || styleValue == "Victoria") && color_arrangement == "Alternating Colors") {
    availableSecondGemstoneColors = gemstoneWhiteLabDiamondColors;
  } else if ((styleValue == "Helena" || styleValue == "Theodora") && color_arrangement == "Alternating Colors") {
    availableSecondGemstoneColors = gemstoneColors;
  }
  
  updateSelectOptions("second_gemstone_color", availableSecondGemstoneColors);
  updateSelectImages("second_gemstone_color", availableSecondGemstoneColors);

  if (availableSecondGemstoneColors.length == 0) {
    $('.secondGemstone').hide();
  } else {
    $('.secondGemstone').show();
  }
  
  // 3rd Color
  var availableThirdGemstoneColors = [];
  
  if (styleValue == "Helena" && color_arrangement == "Alternating Colors") {
    availableThirdGemstoneColors = gemstoneSapphireWithWhiteDiamondColors;
  } else if (styleValue == "Theodora" && color_arrangement == "Alternating Colors") {
    availableThirdGemstoneColors = gemstoneSapphireWithWhiteDiamondColors;
  }
  
  if (availableThirdGemstoneColors.length == 0) {
    $('.thirdGemstone').hide();
  } else {
    $('.thirdGemstone').show();
  }
  
  updateSelectOptions("third_gemstone_color", availableThirdGemstoneColors);
  updateSelectImages("third_gemstone_color", availableThirdGemstoneColors);
  
  // Ring size
  var standardSizes = ["Select Size","Send Ring Sizers","3","3.25","3.5","3.75","4","4.25","4.5","4.75","5","5.25","5.5","5.75","6","6.25","6.5","6.75","7","7.25","7.5","7.75","8","8.25","8.5","8.75","9","9.25","9.5","9.75","10","10.25","10.5","10.75","11","11.25","11.5","11.75","12","12.25","12.5","12.75","13","13.25","13.5","13.75","14","14.25","14.5","14.75","15","15.25","15.5","15.75","16","16.25","16.5","16.75","17","17.25","17.5","17.75","18","18.25","18.5","18.75","19","19.25","19.5","19.75","20","20.25","20.5","20.75","21","21.25","21.5","21.75","22","22.25","22.5","22.75","23","23.25","23.5","23.75","24"];
  var availableSizes = standardSizes;

  updateSelectOptions("ring_size", availableSizes);
}

function joinArrays(array1, array2) {
  var joinArray = [];
  var i;
  for (i = 0; i < array1.length; i++) {
    if (array2.includes(array1[i])) {
      joinArray.push(array1[i]);
    }
  }
  return joinArray;
}

function updateSelectOptions(selectId, newOptions) {
  var oldValue = document.getElementById(selectId).value;
  var id = '#'.concat(selectId);
  /* Remove all options from the select list */
  $(id).empty();

  /* Insert the new ones from the array above */
  var i;
  for (i = 0; i < newOptions.length; i++) {
    var select  = document.getElementById(selectId);
    var option = document.createElement("option");
    if (newOptions[i] == "Other" && selectId == "ring_size") {
      option.text = "Other (specify in notes)";
    } else {
      option.text = newOptions[i];
    }
    if (newOptions[i].includes("Select") || newOptions[i] == "None") {
      option.value = "";
    } else {
      option.value = newOptions[i];
    }
    select.add(option);
  }
  if (newOptions.includes(oldValue)) {
    document.getElementById(selectId).value = oldValue;
  } else {
    document.getElementById(selectId).selectedIndex = 0;
  }
}

function updateSelectImages(selectId, newOptions) {
  // Hide all images
  var sectionName = '.'.concat(selectId);
  $(sectionName).hide();

  // Show available images
  var i;
  for (i = 0; i < newOptions.length; i++) {
    var optionName = sectionName.concat('.').concat(newOptions[i]).replace(/ /g,"_").toLowerCase();
    $(optionName).show();
  }
}

function updateCustomImage() {
  var styles = {"Adelaide": "010", "Alexandra": "011", "Amelia": "012", "Catherine": "013", "Charlotte": "014", "Diana": "015", "Eleanor": "016", "Elizabeth": "017", "Georgiana": "018", "Louise": "019", "Margaret": "020", "Victoria": "021", "Antoinette": "022", "Arabella": "023", "Clarissa": "024", "Emmeline": "025", "Josephine": "026", "Aurelia": "027", "Isabella": "028", "Camilla": "029", "Helena": "030", "Theodora": "031", "Sophia": "032"};
  var ringMaterials = {"Black Titanium": "Z", "Black Zirconium": "Z", "10k Yellow Gold": "10KY", "14k Yellow Gold": "14KY", "18k Yellow Gold": "18KY", "10k White Gold": "10KW", "14k White Gold": "14KW", "18k White Gold": "18KW", "14k Rose Gold": "14KR", "18k Rose Gold": "18KR", "Platinum": "PLAT"};
  var stoneQuantities = {"Eternity": "ETERNITY", "Half Eternity": "HALFETERNITY"};
  var gemstoneColors = {"Aqua Diamond": "AQUADIA", "Black Diamond": "BLKDIA", "Blue Sapphire": "SAPP", "Chocolate Diamond": "COCODIA", "Dark Ruby": "DARKRUBY", "Denim Blue Sapphire": "DENIMSAPP", "Green Diamond": "GREENDIA", "Light Pink Sapphire": "LTPINKSAPP", "Light Yellow Sapphire": "LTYELLOWSAPP", "Ocean Blue Diamond": "OCEANBLUEDIA", "Pink Sapphire": "PINKSAPP", "Purple Diamond": "PURPLEDIA", "Ruby": "RUBY", "White Diamond": "DIA", "White Lab Diamond": "LABDIA", "Yellow Sapphire": "YELLOWSAPP"};
  var colorArrangements = {"Single Color": "B", "Alternating Colors": "A"};
  var variants = {"Adelaide .315 TCW": "1", "Adelaide .45 TCW": "2", "Adelaide .65 TCW": "3", "Adelaide .77 TCW": "4", "Alexandra .6 TCW": "1", "Alexandra .84 TCW": "2", "Alexandra 1.1 TCW": "3", "Amelia .33 TCW": "1", "Amelia .9 TCW": "2","Catherine .225 TCW": "1", "Catherine .36 TCW": "2", "Catherine .5 TCW": "3", "Catherine .63 TCW": "4", "Charlotte .27 TCW": "1", "Charlotte .39 TCW": "2", "Charlotte .55 TCW": "3", "Charlotte .77 TCW": "4", "Diana .27 TCW": "1", "Diana .39 TCW": "2", "Diana .55 TCW": "3", "Diana .77 TCW": "4", "Eleanor .285 TCW": "1", "Eleanor .62 TCW": "2", "Eleanor .85 TCW": "3", "Elizabeth .285 TCW": "1", "Elizabeth .62 TCW": "2", "Elizabeth .85 TCW": "3", "Georgiana .315 TCW": "1", "Georgiana .45 TCW": "2", "Georgiana .65 TCW": "3", "Georgiana .77 TCW": "4", "Louise .33 TCW": "1", "Louise .68 TCW": "2", "Margaret .69 TCW": "1", "Margaret 1.08 TCW": "2", "Margaret 1.5 TCW": "3", "Victoria .56 TCW": "1", "Antoinette .78 TCW": "1", "Antoinette 1.38 TCW": "2", "Antoinette 1.72 TCW": "3", "Antoinette 2.15 TCW": "4", "Arabella 1.32 TCW": "1", "Clarissa .825 TCW": "1", "Clarissa 1.29 TCW": "2", "Clarissa 1.85 TCW": "3", "Emmeline 1.395 TCW": "1", "Josephine .87 TCW": "1", "Aurelia .39 TCW": "1", "Aurelia .54 TCW": "2", "Aurelia .8 TCW": "3", "Isabella .195 TCW": "1", "Isabella .27 TCW": "2", "Isabella .4 TCW": "3", "Camilla .27 TCW": "1", "Camilla .47 TCW": "2", "Helena .39 TCW": "1", "Helena .42 TCW": "2", "Theodora .23 TCW": "1", "Theodora .27 TCW": "2", "Sophia .62 TCW": "1"}
  
  var styleInput = document.getElementById("style");
  var style = styles[styleInput.value];
  var materialInput = document.getElementById("material");
  var material = ringMaterials[materialInput.value];
  var stoneQuantityInput = document.getElementById("stone_quantity");
  var stoneQuantity = stoneQuantities[stoneQuantityInput.value];
  var firstGemstonetColorInput = document.getElementById("first_gemstone_color");
  var firstGemstoneColor = gemstoneColors[firstGemstonetColorInput.value];
  var secondGemstonetColorInput = document.getElementById("second_gemstone_color");
  var secondGemstoneColor = gemstoneColors[secondGemstonetColorInput.value];
  var thirdGemstonetColorInput = document.getElementById("third_gemstone_color");
  var thirdGemstoneColor = gemstoneColors[thirdGemstonetColorInput.value];
  var colorArrangementInput = document.getElementById("color_arrangement");
  var colorArrangement = colorArrangements[colorArrangementInput.value];
  var caratWeightInput = document.getElementById("carat_weight");
  var variantKeyValue = styleInput.value.concat(" ").concat(caratWeightInput.value);
  var variant = variants[variantKeyValue];
  
  var gemstoneColor = firstGemstoneColor;
  if (secondGemstonetColorInput.value != "") {
    gemstoneColor = gemstoneColor.concat(",").concat(secondGemstoneColor);
  }if (thirdGemstonetColorInput.value != "") {
    gemstoneColor = gemstoneColor.concat(",").concat(thirdGemstoneColor);
  }

  var ringSize = document.getElementById("ring_size").value;
  if (ringSize == null || ringSize == 'Send Ring Sizers') {
    ringSize = "10";
  }

  var src = "/women/rings/styles/";
  src = src.concat(style);
  src = src.concat("/ring_materials/");
  src = src.concat(material);
  src = src.concat("/color_arrangements/")
  src = src.concat(colorArrangement);
  src = src.concat("/stone_quantities/");
  src = src.concat(stoneQuantity);
  src = src.concat("/variants/");
  src = src.concat(variant);
  src = src.concat("?size=");
  src = src.concat(ringSize);
  src = src.concat("&dia=");
  src = src.concat(gemstoneColor);
  
  // src = src.concat("&watermark=false");

  console.log("SRC:");
  console.log(src);

  if ($('#mobileCustomImg').first().is(':visible')) {
    document.getElementById("centerLoad").style.display = "block";
  }
  
  if ($('#leftMobileCustomImg').first().is(':visible')) {
    document.getElementById("leftLoad").style.display = "block";
  }
  
  if ($('#rightMobileCustomImg').first().is(':visible')) {
    document.getElementById("rightLoad").style.display = "block";
  }
  
  document.getElementById("topImgLoad").style.display = "block";
  
  updatePrice(src);
  getURLQuery();
}

function drawSmallImage(img) {
  document.getElementById("centerLoad").style.display = "none";

  var canvas = document.getElementById("mobileCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 200;
  img.height = 200;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 200, 200);
  ctx.drawImage(img, 0, 0, 200, 200);
  ctx.fillRect(150, 180, 200, 200);
}

function drawSmallLeftImage(img) {
  document.getElementById("leftLoad").style.display = "none";

  var canvas = document.getElementById("leftMobileCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 200;
  img.height = 200;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 200, 200);
  ctx.drawImage(img, 0, 0, 200, 200);
  ctx.fillRect(150, 180, 200, 200);
}

function drawSmallRightImage(img) {
  document.getElementById("rightLoad").style.display = "none";

  var canvas = document.getElementById("rightMobileCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 200;
  img.height = 200;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 200, 200);
  ctx.drawImage(img, 0, 0, 200, 200);
  ctx.fillRect(150, 180, 200, 200);
}

function drawLargeImage(img) {
  document.getElementById("topImgLoad").style.display = "none";

  var canvas = document.getElementById("topImg");
  var ctx = canvas.getContext("2d");
  img.width = 700;
  img.height = 700;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 700, 700);
  ctx.drawImage(img, 0, 0, 700, 700);
  ctx.fillRect(525, 630, 700, 700);
}

function drawLargeCenterImage(img) {
  document.getElementById("modalImgLoad").style.display = "none";
  document.getElementById("modalCustomImg").style.display = "block";

  var canvas = document.getElementById("modalCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 700;
  img.height = 700;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 700, 700);
  ctx.drawImage(img, 0, 0, 700, 700);
  ctx.fillRect(525, 630, 700, 700);
}

function drawLargeLeftImage(img) {
  document.getElementById("modalImgLoad").style.display = "none";
  document.getElementById("leftModalCustomImg").style.display = "block";

  var canvas = document.getElementById("leftModalCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 700;
  img.height = 700;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 700, 700);
  ctx.drawImage(img, 0, 0, 700, 700);
  ctx.fillRect(525, 630, 700, 700);
}

function drawLargeRightImage(img) {
  document.getElementById("modalImgLoad").style.display = "none";
  document.getElementById("rightModalCustomImg").style.display = "block";

  var canvas = document.getElementById("rightModalCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 700;
  img.height = 700;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 700, 700);
  ctx.drawImage(img, 0, 0, 700, 700);
  ctx.fillRect(525, 630, 700, 700);
}

function showModal(image) {
  // Get the modal
  var modal = document.getElementById("imageModal");
  var src = document.getElementById("imageURL").value;

  // gtag('event', 'show-modal', {'action': 'click', 'label': image }); 

  document.getElementById("leftModalCustomImg").style.display = "none";
  document.getElementById("modalCustomImg").style.display = "none";
  document.getElementById("rightModalCustomImg").style.display = "none";

  modal.style.display = "block";
  if(image == 'left') {
    document.getElementById("modalImgLoad").style.display = "block";

    var largeLeftImg = new Image();
    src = src.replace("images/1","images/2");
    largeLeftImg.src = src;
    largeLeftImg.crossOrigin = "Anonymous";
    largeLeftImg.addEventListener("load", function() { drawLargeLeftImage(largeLeftImg); }, false);
  } else if (image == 'right') {
    document.getElementById("modalImgLoad").style.display = "block";

    var largeRightImg = new Image();
    src = src.replace("images/1","images/3");
    largeRightImg.src = src;
    largeRightImg.crossOrigin = "Anonymous";
    largeRightImg.addEventListener("load", function() { drawLargeRightImage(largeRightImg); }, false);
  } else {
    document.getElementById("modalImgLoad").style.display = "block";

    var largeImg = new Image();
    largeImg.src = src;
    largeImg.crossOrigin = "Anonymous";
    largeImg.addEventListener("load", function() { drawLargeCenterImage(largeImg); }, false);
  }
}

function hideModal() {
  var modal = document.getElementById("imageModal");

  modal.style.display = "none";
  document.getElementById("leftModalCustomImg").style.display = "none";
  document.getElementById("modalCustomImg").style.display = "none";
  document.getElementById("rightModalCustomImg").style.display = "none";
}

function showAlertModal() {
  var modal = document.getElementById("alertModal");
  modal.style.display = "block";
  setTimeout(function(){ document.getElementById("alertModal").style.display = "none"; }, 5000);
}

function sticky_relocate() {
  var stickyModalSize = 248;
  var headerSize = 100;
  var window_top = Math.round($(window).scrollTop());
  var div_top = $('.pattern-heading').eq(0).offset().top;
  if (window_top > (div_top - stickyModalSize)) {
    document.getElementById("leftMobileCustomImg").style.display = "block";
    document.getElementById("leftIconContainer").style.display = "block";
    document.getElementById("leftMagIcon").style.display = "block";
    document.getElementById("mobileCustomImg").style.display = "block";
    document.getElementById("iconContainer").style.display = "block";
    document.getElementById("magIcon").style.display = "block";
    document.getElementById("rightMobileCustomImg").style.display = "block";
    document.getElementById("rightIconContainer").style.display = "block";
    document.getElementById("rightMagIcon").style.display = "block";
    document.getElementById("mobileHeader").style.display = "block";
    document.getElementById("price").style.display = "block";
    document.getElementById("mobileImgContainer").style.height = stickyModalSize + "px";
  } else {
    document.getElementById("leftMobileCustomImg").style.display = "none";
    document.getElementById("leftIconContainer").style.display = "none";
    document.getElementById("leftMagIcon").style.display = "none";
    document.getElementById("mobileCustomImg").style.display = "none";
    document.getElementById("iconContainer").style.display = "none";
    document.getElementById("magIcon").style.display = "none";
    document.getElementById("rightMobileCustomImg").style.display = "none";
    document.getElementById("rightIconContainer").style.display = "none";
    document.getElementById("rightMagIcon").style.display = "none";
    document.getElementById("mobileHeader").style.display = "none";
    document.getElementById("price").style.display = "none";
    document.getElementById("mobileImgContainer").style.height = "0px";
  }

  var i;
  for (i = 0; i < $('.pattern-heading').length; i++) {
    var headingTop = Math.round($('.pattern-heading').eq(i).offset().top);

    if ($('.pattern-heading').eq(i).is(':visible')) {
      if (i + 1 < $('.pattern-heading').length) {
        var nextHeadingTop = Math.round($('.pattern-heading').eq(i + 1).offset().top);

        if (i == 0 && window_top < nextHeadingTop - stickyModalSize) {
          var headerText = $('.pattern-heading')[i].innerText.replace(" (collapse)","").replace(" (expand)","").replace(/\r?\n|\r/g, "");
          var collapseText = headerText.replace(/ /g,"-").toLowerCase();
          var collapseField = document.getElementById(collapseText.concat("-collapse-field"));
          if (collapseField != undefined) {
            document.getElementById('mobileHeader').innerHTML = "<div onclick=\"collapseSection('".concat(collapseText).concat("');\"><p>").concat(headerText).concat(" <span class=\"shrink-link\" id=\"top-collapse-field\">".concat(collapseField.innerText).concat("</span></p></div>"));
          } else {
            document.getElementById('mobileHeader').innerHTML = "<div><p>".concat(headerText).concat("</p></div>");
          }
        } else if (window_top >= headingTop - stickyModalSize && (window_top < nextHeadingTop - stickyModalSize || !$('.pattern-heading').eq(i+1).is(':visible'))) {
          var headerText = $('.pattern-heading')[i].innerText.replace(" (collapse)","").replace(" (expand)","").replace(/\r?\n|\r/g, "");
          var collapseText = headerText.replace(/ /g,"-").toLowerCase();
          var collapseField = document.getElementById(collapseText.concat("-collapse-field"));
          if (collapseField != undefined) {
            document.getElementById('mobileHeader').innerHTML = "<div onclick=\"collapseSection('".concat(collapseText).concat("');\"><p>").concat(headerText).concat(" <span class=\"shrink-link\" id=\"top-collapse-field\">".concat(collapseField.innerText).concat("</span></p></div>"));
          } else {
            document.getElementById('mobileHeader').innerHTML = "<div><p>".concat(headerText).concat("</p></div>");
          }
        }
      } else {
        if (window_top >= headingTop - stickyModalSize) {
          var headerText = $('.pattern-heading')[i].innerText.replace(" (collapse)","").replace(" (expand)","").replace(/\r?\n|\r/g, "");
          var collapseText = headerText.replace(/ /g,"-").toLowerCase();
          var collapseField = document.getElementById(collapseText.concat("-collapse-field"));
          if (collapseField != undefined) {
            document.getElementById('mobileHeader').innerHTML = "<div onclick=\"collapseSection('".concat(collapseText).concat("');\"><p>").concat(headerText).concat(" <span class=\"shrink-link\" id=\"top-collapse-field\">".concat(collapseField.innerText).concat("</span></p></div>"));
          } else {
            document.getElementById('mobileHeader').innerHTML = "<div><p>".concat(headerText).concat("</p></div>");
          }
        }
      }
    }
  }
}

function changeSection(button) {
  var stickyModalSize = 248;
  var window_top = Math.round($(window).scrollTop());
  var prevSection = -1;
  var nextSection = -1;

  // if (button == 'next') {
  //   gtag('event', 'previous-next', {'action': 'next' }); 
  // } else {
  //   gtag('event', 'previous-next', {'action': 'previous' }); 
  // }

  var i;
  for (i = 0; i < $('.pattern-heading').length; i++) {
    var headingTop = Math.round($('.pattern-heading').eq(i).offset().top);

    if ($('.pattern-heading').eq(i).is(':visible')) {
      if (i + 1 < $('.pattern-heading').length) {
        var nextHeadingTop;
        var j;
        for (j = i + 1; j < $('.pattern-heading').length; j++) {
          if ($('.pattern-heading').eq(j).is(':visible')) {
            nextHeadingTop = Math.round($('.pattern-heading').eq(j).offset().top);
            break;
          }
        }

        if (i == 0 && window_top < nextHeadingTop - stickyModalSize) {
          prevSection = -1;
          nextSection = -1;
        } else if (i == 1 && window_top > headingTop - stickyModalSize && window_top < nextHeadingTop - stickyModalSize) {
          prevSection = -1;
          for (j = i + 1; j < $('.pattern-heading').length; j++) {
            if ($('.pattern-heading').eq(j).is(':visible')) {
              break;
            }
          }
          nextSection = j;
        } else if (window_top >= headingTop - stickyModalSize && window_top < nextHeadingTop - stickyModalSize) {
          for (j = i - 1; j > 0; j--) {
            if ($('.pattern-heading').eq(j).is(':visible')) {
              break;
            }
          }
          prevSection = j;
          for (j = i + 1; j < $('.pattern-heading').length; j++) {
            if ($('.pattern-heading').eq(j).is(':visible')) {
              break;
            }
          }
          nextSection = j;
        }
      } else {
        if (window_top >= headingTop - stickyModalSize) {
          for (j = i - 1; j > 0; j--) {
            if ($('.pattern-heading').eq(j).is(':visible')) {
              break;
            }
          }
          prevSection = j;
          nextSection = -1;
        }
      }
    }
  }

  if (button == "previous" && prevSection != -1) {
    var offsetPosition = $('.pattern-heading').eq(prevSection).offset().top - stickyModalSize;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  } else if (button == "next" && nextSection != -1) {
    var offsetPosition = $('.pattern-heading').eq(nextSection).offset().top - stickyModalSize;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
}

function collapseSection(sectionName){
  var stickyModalSize = 248;
  var topField = document.getElementById("top-collapse-field");
  var mobileHeader = document.getElementById("mobileHeader");

  var collapseFieldName = sectionName.concat("-collapse-field");
  var collapseField = document.getElementById(collapseFieldName);

  var collapseName = sectionName.concat("-collapse");
  var collapse = document.getElementById(collapseName);

  if (collapseField.innerText == "(collapse)") {
    // gtag('event', 'collapse-expand', {'action': 'collapse', 'label': sectionName }); 
    $(collapse).hide();
    collapseField.innerText = "(expand)";
    if (mobileHeader.innerText.toLowerCase() == sectionName.replace(/-/g," ").concat(" (collapse)")) {
      topField.innerText = "(expand)";
    }
    var collapseFieldNameId = "#".concat(collapseFieldName);
    var offsetPosition = $(collapseFieldNameId).offset().top - stickyModalSize;
    window.scrollTo({
      top: offsetPosition,
      behavior: "auto"
    });
  } else {
    // gtag('event', 'collapse-expand', {'action': 'expand', 'label': sectionName }); 
    collapseField.innerText = "(collapse)";
    $(collapse).show();
    if (mobileHeader.innerText.toLowerCase() == sectionName.replace(/-/g," ").concat(" (expand)")) {
      topField.innerText = "(collapse)";
    }
  }
}

function verifySubmit(e) {
  e.preventDefault();
  var invalidRushDate = false;
  var rushDate = document.getElementById('rushDate').value;
  
  if (rushDate != "") {
    var rushDateDate = new Date(rushDate);
    var minRushDate = document.getElementById('rushDate').getAttribute('min');
    var minRushDateDate = new Date(minRushDate);
    if (rushDateDate < minRushDateDate) {
      invalidRushDate = true;
    }
  }

  var name = document.getElementById('name').value;
  var email = document.getElementById('email').value;
  if (invalidRushDate) {
    var alertMessage = "The rush date cannot be any sooner than two weeks from today.";
    document.getElementById('rushDate').focus();
    alert(alertMessage);
  } else if (name != "" && email != "") {
    grecaptcha.ready(function() {
      grecaptcha.execute('6LeLwI4kAAAAANWEbOpzGXY-pITFa6Qngo4OOiZp', {action: 'sumbitForm'}).then(function(token) {
        document.getElementById("token").value = token;
        document.getElementById("moreInfoForm").submit();
      });
    });
  } else {
    var missingFields = [];
    if (name == "") {
      missingFields.push("name");
    }
    if (email == "") {
      missingFields.push("email");
    }

    if (missingFields.length == 2) {
      var alertMessage = "Please provide your ";
      for (i = 0; i < missingFields.length; i++) {
        var name = missingFields[i];
        document.getElementById(missingFields[i]).style.border = '#a71616 2px solid';
        if (i == (missingFields.length - 1)) {
          alertMessage = alertMessage.concat("and ".concat(name));
        } else {
          alertMessage = alertMessage.concat(name).concat(" ");
        }
      }
      alertMessage = alertMessage.concat(".");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    } else if (missingFields.length == 1) {
      var name = missingFields[0];
      document.getElementById(missingFields[0]).style.border = '#a71616 2px solid';
      var alertMessage = "Please provide your ".concat(name).concat(".");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    }
  }
}

function submitInvoice() {
  var style = document.getElementById('style').value;
  var material = document.getElementById('material').value;
  var stoneQuantity = document.getElementById('stone_quantity').value;
  var firstGemstoneColor = document.getElementById('first_gemstone_color').value;
  var secondGemstoneColor = document.getElementById('second_gemstone_color').value;
  var thirdGemstoneColor = document.getElementById('third_gemstone_color').value;
  var colorArrangement = document.getElementById('color_arrangement').value;
  var caratWeight = document.getElementById('carat_weight').value;
  var ringSize = document.getElementById('ring_size').value;
  var rushDate = document.getElementById('rushDate').value;
  var notes = document.getElementById('notes').value;
  var name = document.getElementById('name').value;
  var email = document.getElementById('email').value;
  var origin = document.getElementById('origin').value;
  var priceEstimate = document.getElementById('price_estimate').value;
  var salePriceEstimate = document.getElementById('sale_price_estimate').value;
  var imageURL = document.getElementById('imageURL').value;
  var customInvoiceButton = document.getElementById('customInvoice');
  var invalidRushDate = false;

  if (rushDate != "") {
    var rushDateDate = new Date(rushDate);
    var minRushDate = document.getElementById('rushDate').getAttribute('min');
    var minRushDateDate = new Date(minRushDate);
    if (rushDateDate < minRushDateDate) {
      invalidRushDate = true;
    }
  }

  if (invalidRushDate) {
    var alertMessage = "The rush date cannot be any sooner than two weeks from today.";
    document.getElementById('rushDate').focus();
    alert(alertMessage);
  } else if (name != "" && email != "" && ringSize != "") {
    grecaptcha.ready(function() {
      grecaptcha.execute('6LeLwI4kAAAAANWEbOpzGXY-pITFa6Qngo4OOiZp', {action: 'sumbitForm'}).then(function(token) {
        document.getElementById("token").value = token;
        
        customInvoiceButton.disabled = true;
        customInvoiceButton.style.backgroundColor = "#777";
    
        $.ajax({
          type: "POST",
          url: "https://custom.stonebrookjewelry.com/origin/invoice_submit.php",
          data: { style: style, material: material, stone_quantity: stoneQuantity, first_gemstone_color: firstGemstoneColor, second_gemstone_color: secondGemstoneColor, third_gemstone_color: thirdGemstoneColor, color_arrangement: colorArrangement, carat_weight: caratWeight, ring_size: ringSize, rushDate: rushDate, notes: notes, name: name, email: email, origin: origin, price_estimate: priceEstimate, sale_price_estimate: salePriceEstimate, imageURL: imageURL, token: token },
          success: function(returnedData){
            // Do something on success
            var customInvoiceButton = document.getElementById('customInvoice');
    
            customInvoiceButton.disabled = false;
            customInvoiceButton.style.backgroundColor = "#5274b6";
    
            if (returnedData.success == "true") {
              window.location.href = "https://originjewelry.com/pages/thank-you-custom-invoice?id="+returnedData.id;
            } else {
              if (returnedData.code == "missing_data_email_sent" || returnedData.code == "price_mismatch_email_sent") {
                window.location.href = "https://originjewelry.com/pages/thank-you-custom-request";
              } else {
                alert("There was an issue sending your request. Please try again.");
              }
            }
          },
          error: function(XMLHttpRequest, textStatus, errorThrown) {
            // Do something on error
            customInvoiceButton.disabled = false;
            customInvoiceButton.style.backgroundColor = "#5274b6";
    
            console.log("XMLHttpRequest: ");
            console.log(XMLHttpRequest);
            console.log("textStatus: ");
            console.log(textStatus);
            console.log("errorThrown: ");
            console.log(errorThrown);
    
            alert("There was an issue sending your request. Please try again.");
          }
        });
      });
    });
  } else {
    var missingFields = [];
    if (ringSize == "") {
      missingFields.push("ring_size");
    }
    if (name == "") {
      missingFields.push("name");
    }
    if (email == "") {
      missingFields.push("email");
    }

    if (missingFields.length == 4 || missingFields.length == 3) {
      var alertMessage = "Please provide your ";
      for (i = 0; i < missingFields.length; i++) {
        var name = missingFields[i];
        if (name == "ring_size") {
          name = "ring size";
        }
        document.getElementById(missingFields[i]).style.border = '#a71616 2px solid';
        if (i == (missingFields.length - 1)) {
          alertMessage = alertMessage.concat("and ".concat(name));
        } else {
          alertMessage = alertMessage.concat(name).concat(", ");
        }
      }
      alertMessage = alertMessage.concat(" so we can send the invoice.");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    } else if (missingFields.length == 2) {
      var alertMessage = "Please provide your ";
      for (i = 0; i < missingFields.length; i++) {
        var name = missingFields[i];
        if (name == "ring_size") {
          name = "ring size";
        }
        document.getElementById(missingFields[i]).style.border = '#a71616 2px solid';
        if (i == (missingFields.length - 1)) {
          alertMessage = alertMessage.concat("and ".concat(name));
        } else {
          alertMessage = alertMessage.concat(name).concat(" ");
        }
      }
      alertMessage = alertMessage.concat(" so we can send the invoice.");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    } else if (missingFields.length == 1) {
      var name = missingFields[0];
      if (name == "ring_size") {
        name = "ring size";
      }
      document.getElementById(missingFields[0]).style.border = '#a71616 2px solid';
      var alertMessage = "Please provide your ".concat(name).concat(" so we can send the invoice.");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    }
  }
}

function checkEmpty(name) {
  if (document.getElementById(name).value != "") {
    document.getElementById(name).style.border = '1px solid #cccccc';
  }
}

function checkDislaimers() {
  var rushDate = document.getElementById("rushDate").value;
  var ringSize = document.getElementById("ring_size").value;

  if (rushDate != "" && ringSize == "Send Ring Sizers") {
    document.getElementById("rushSizerDisclaimer").style.display = 'block';
  } else {
    document.getElementById("rushSizerDisclaimer").style.display = 'none';
  }
  if (rushDate != "") {
    document.getElementById("rushInternationalDisclaimer").style.display = 'block';
  } else {
    document.getElementById("rushInternationalDisclaimer").style.display = 'none';
  }
}

function clearRushDate() {
  document.getElementById("rushDate").value = "";
}

$(function() {
  $(window).scroll(sticky_relocate);
  sticky_relocate();
});